import { isNotEmptyValue } from "kwikid-toolkit";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isString = (x: string) => typeof x === "string";

  const methods = {
    config: (x: any) => isNotEmptyValue(x),
    id: isString
  };

  return methods[key] && methods[key](value);
};
